import { render, staticRenderFns } from "./PageWorldABC.vue?vue&type=template&id=ee7b91a6&scoped=true&"
import script from "./PageWorldABC.vue?vue&type=script&lang=js&"
export * from "./PageWorldABC.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldABC.vue?vue&type=style&index=0&id=ee7b91a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7b91a6",
  null
  
)

export default component.exports